import API from './api';

const isTransientBackendError = (error) => (
  error?.code === 'ERR_NETWORK'
  || error?.code === 'ECONNABORTED'
  || [502, 503, 504].includes(error?.response?.status)
);

// Lấy trạng thái hệ thống hiện tại
export const getSystemStatus = async () => {
  try {
    const response = await API.get('/system-status', {
      timeout: 10000,
      retry: 0,
      skipErrorInterceptorLog: true
    });
    return response.data;
  } catch (error) {
    if (!isTransientBackendError(error)) {
      console.error('Error fetching system status:', error);
    }
    throw error;
  }
};

// Cập nhật trạng thái hệ thống (chỉ SUPER_ADMIN)
export const updateSystemStatus = async (statusData) => {
  try {
    const response = await API.post('/system-status', statusData);
    return response.data;
  } catch (error) {
    console.error('Error updating system status:', error);
    throw error;
  }
};

// Lấy lịch sử trạng thái hệ thống (chỉ SUPER_ADMIN)
export const getSystemStatusHistory = async () => {
  try {
    const response = await API.get('/system-status/history');
    return response.data;
  } catch (error) {
    console.error('Error fetching system status history:', error);
    throw error;
  }
};

// Chỉnh sửa một bản ghi lịch sử trạng thái hệ thống (chỉ SUPER_ADMIN)
export const editSystemStatusHistory = async (id, statusData) => {
  try {
    const response = await API.put(`/system-status/history/${id}`, statusData);
    return response.data;
  } catch (error) {
    console.error('Error editing system status history:', error);
    throw error;
  }
};

// Xóa một bản ghi lịch sử trạng thái hệ thống (chỉ SUPER_ADMIN)
export const deleteSystemStatusHistory = async (id) => {
  try {
    const response = await API.delete(`/system-status/history/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting system status history:', error);
    throw error;
  }
};